import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { ChoosePlanPromptSettings, markShownThisSession, shouldOpenChoosePlan } from '../utils/choosePlan';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

// Renders nothing. After login the dashboard mounts this; if the user should be prompted
// (pending selection from Pricing, or unpaid per the admin settings) it opens /choose-plan.
const ChoosePlanGate = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const userId = user?.id;

  useEffect(() => {
    if (!userId) return;
    let cancelled = false;
    (async () => {
      try {
        const [catalogRes, meRes] = await Promise.all([
          fetch(`${API_BASE}/api/pricing/catalog`, { credentials: 'include' }),
          fetch(`${API_BASE}/api/me/pricing`, { credentials: 'include' }),
        ]);
        if (!catalogRes.ok || !meRes.ok) return;
        const catalog = (await catalogRes.json()) as { choosePlanPrompt?: ChoosePlanPromptSettings };
        const me = (await meRes.json()) as { assignedPlan?: { id: string } | null };
        if (cancelled) return;
        const open = shouldOpenChoosePlan({
          userId,
          settings: catalog.choosePlanPrompt ?? { enabled: true, repromptDays: 0 },
          hasAssignedPlan: Boolean(me.assignedPlan),
        });
        if (open) {
          markShownThisSession(userId);
          navigate('/choose-plan', { replace: true });
        }
      } catch {
        // Prompt is a nicety; never block the dashboard on it.
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [userId, navigate]);

  return null;
};

export default ChoosePlanGate;
